module.exports = __webpack_public_path__ + "static/media/mokuroku-home-books1.d264d436.svg";